/*
	This module provides non-reactive storage for the product catalog data.
	It allows setting and getting the product catalog without making it reactive,
	which is very useful for performance optimization.
	Some caution should be taken because the processed data is still being passed in the getter,
	and this could lead to components caching stale data.
*/

let catalog = null;

export function setNonReactiveProductCatalog(data) {
	catalog = null; // Clear the old reference before setting new data
	catalog = Object.freeze(data);
}

export function getNonReactiveProductCatalog() {
	return catalog;
}

export function isProductCatalogDataAvailable() {
	return catalog && catalog.products && catalog.products.length > 0;
}